export interface LoginState {
  selectedChannel?: 'phone' | 'email' | 'emailAndPhone';
  authToken: string;
  success: boolean;
}

const state: LoginState = {
  selectedChannel: undefined,
  authToken: '',
  success: false,
};

export default state;
